 //上周
 export const onweek = () => {
    var systemDate = new Date();
    var year = systemDate.getFullYear();
    var month = systemDate.getMonth() + 1;
    var day =  systemDate.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    var now = new Date();
    var date = new Date(now.getTime() - 7 * 24 * 3600 * 1000);
    var year1 = date.getFullYear();
    var month1 = date.getMonth() + 1;
    var day1 = date.getDate();
     if (day1 < 10) {
        day1 = '0' + day1;
    }
    if (month < 10) {
        month1 = '0' + month1;
    }
    var time2 = year1 +'-'+ month1 +'-'+ day1
    var time1 =  year +'-'+ month +'-'+ day
    return [time2,time1]
}
//今天
export const today = () => {
    var systemDate = new Date();
    var year = systemDate.getFullYear();
    var month = systemDate.getMonth() + 1;
    var day =  systemDate.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }

    var time =  year +'-'+ month +'-'+ day
    return [time,time]
}

//明天
export const tomorrow = () => {
  var dd = new Date();
  dd.setDate(dd.getDate()+1);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0
  var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0
  var time = y+"-"+ m +"-"+d
  return [time,time]
}

//昨天
export const yesterday = () => {
  var dd = new Date();
  dd.setDate(dd.getDate()-1);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0
  var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0
  var time = y+"-"+ m +"-"+d
  return [time,time]
}

//昨天到今天
export const Fromday = () => {
  var dd = new Date();
  dd.setDate(dd.getDate()-1);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0
  var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0
  var time = y+"-"+ m +"-"+d
    var systemDate = new Date();
    var year = systemDate.getFullYear();
    var month = systemDate.getMonth() + 1;
    var day =  systemDate.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    var time1 =  year +'-'+ month +'-'+ day
    return [time,time1]
}

var now,nowDayOfWeek,nowDay,nowMonth,nowYear,lastMonthDate1,lastYear,lastMonth

function ininData(){
  now = new Date(); //当前日期
  nowDayOfWeek = now.getDay(); //今天本周的第几天
  nowDay = now.getDate(); //当前日
  nowMonth = now.getMonth(); //当前月
  nowYear = now.getYear(); //当前年
  nowYear += (nowYear < 2000) ? 1900 : 0; //
  lastMonthDate1 = new Date(); //上月日期
  lastMonthDate1.setDate(1);
  lastMonthDate1.setMonth(lastMonthDate1.getMonth()-1);
  lastYear = lastMonthDate1.getYear();
  lastMonth = lastMonthDate1.getMonth();
}


function formatDate(date) {
  var myyear = date.getFullYear();
  var mymonth = date.getMonth()+1;
  var myweekday = date.getDate();

  if(mymonth < 10){
      mymonth = "0" + mymonth;
  }
  if(myweekday < 10){
      myweekday = "0" + myweekday;
  }
  return (myyear+"-"+mymonth + "-" + myweekday);
}

//获得某月的天数
function getMonthDays(myMonth){
  var monthStartDate = new Date(nowYear, myMonth, 1);
  var monthEndDate = new Date(nowYear, myMonth + 1, 1);
  var days = (monthEndDate - monthStartDate)/((1000 * 60 * 60 * 24));
  return days;
}

//本周
export const week = () => {
      ininData()
      var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
      var weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
      return [ formatDate(weekStartDate),formatDate(weekEndDate)]
}

//本月未格式化
export const formattingMonth = () => {
     ininData()
     var monthStartDate = new Date(nowYear, nowMonth, 1);
     var monthEndDate = new Date();
     return [ monthStartDate,monthEndDate]
}
//本月
export const month = () => {
  ininData()
  var monthStartDate = new Date(nowYear, nowMonth, 1);
  var monthEndDate = new Date();
  console.log(monthStartDate);
  return [ formatDate(monthStartDate),formatDate(monthEndDate)]
}

//上月未格式化
export const formattingOnMonth= () => {
  ininData()
   var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
   var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));

    return [ lastMonthStartDate,lastMonthEndDate]
}
//上月
export const onMonth = () => {
  ininData()
  var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
  var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));

   return [ formatDate(lastMonthStartDate),formatDate(lastMonthEndDate)]
}


//上周
export const getTime = (n) => {
  var now = new Date();
  var year = now.getFullYear();
  //因为月份是从0开始的,所以获取这个月的月份数要加1才行
  var month = now.getMonth() + 1;
  var date = now.getDate();
  var day = now.getDay();
  //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
  if (day !== 0) {
    n = n + (day - 1);
  } else {
    n = n + day;
  }
  if (day) {
    //这个判断是为了解决跨年的问题
    if (month > 1) {
      month = month;
    }
    //这个判断是为了解决跨年的问题,月份是从0开始的
    else {
      year = year - 1;
      month = 12;
    }
  }
  now.setDate(now.getDate() - n);
  year = now.getFullYear();
  month = now.getMonth() + 1;
  date = now.getDate();
  var s = year + "-" + (month < 10 ? ('0' + month) : month) + "-" + (date < 10 ? ('0' + date) : date);
  return s;
}
//上个月最后一天
export const lastMonthDate = () => {
  var nowdays = new Date();
  var year = nowdays.getFullYear();
  var month = nowdays.getMonth();
  if(month==0){
      month = 12;
      year = year-1;
  }
  if(month<10){
      month = '0'+month;
  }
  var myDate = new Date(year,month,0);
  var startDate = new Date(year+'-'+month+'-01 00:00:00'); //上个月第一天
  var endDate = new Date(year+'-'+month+'-'+myDate.getDate()+' 23:59:59')
  return [startDate,endDate]
}





